import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconProjects: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"projects, stack, templates, timeline"} maskId="square-filled-radius-0-stroke-1-IconProjects"><path d="M21.9932 9.58984L19.9932 20.5898L19.918 21H4.08398L4.00879 20.5898L2.00879 9.58984L1.90234 9H22.0996L21.9932 9.58984Z" fill="currentColor"/><path d="M20.001 7H4.00098V6H20.001V7Z" fill="currentColor"/><path d="M18.001 4H6.00098V3H18.001V4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconProjects;
